import { ExternalLink } from "lucide-react";
import Seo from "@/components/Seo";
import { show } from "@/lib/podcast";
import { siteConfig } from "@/config/siteConfig";

export default function About() {
  const { about } = siteConfig;
  return (
    <div data-testid="about-page">
      <Seo
        title="About"
        description={`About ${show.title} and host ${about.host.name}. ${show.description}`}
        image={show.image}
        path="/about"
      />

      <section className="hero-bg border-b border-[#0b1f4d]/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#9a6700]">
            About the show
          </span>
          <h1 className="font-poster uppercase text-5xl sm:text-6xl text-[#0b1f4d] mt-2 tracking-tight">
            {show.title}
          </h1>
          <div className="mt-6 space-y-5 text-lg text-[#374566] leading-relaxed">
            {about.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="bg-white rounded-lg border border-[#0b1f4d]/10 p-6 sm:p-10">
          <div className="flex flex-col sm:flex-row gap-8">
            {show.person?.img && (
              <img
                src={show.person.img}
                alt={about.host.name}
                className="h-32 w-32 rounded-lg object-cover ring-1 ring-[#0b1f4d]/10 shrink-0"
              />
            )}
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#9a6700]">
                {about.host.role}
              </span>
              <h2 className="font-display uppercase text-3xl font-semibold text-[#0b1f4d] mt-1">
                {about.host.name}
              </h2>
              <div className="mt-4 space-y-4 text-[#374566] leading-relaxed">
                {about.host.bio.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
              {about.host.link && (
                <a
                  href={about.host.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="about-host-link"
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#374566] hover:text-[#9a6700] transition-colors"
                >
                  {about.host.link.replace(/^https?:\/\//, "")}{" "}
                  <ExternalLink size={15} />
                </a>
              )}
            </div>
          </div>
        </div>

        <dl className="mt-8 grid sm:grid-cols-3 gap-4">
          {[
            ["Focus", show.categories?.join(" · ") || "Society & Culture"],
            ["Based in", show.location || "United States"],
            ["Host", about.host.name],
          ].map(([k, v]) => (
            <div
              key={k}
              className="rounded-md border border-[#0b1f4d]/10 bg-white px-5 py-4"
            >
              <dt className="font-mono text-xs uppercase tracking-widest text-[#66718d]">
                {k}
              </dt>
              <dd className="mt-1 font-semibold text-[#0b1f4d]">{v}</dd>
            </div>
          ))}
        </dl>
      </section>
    </div>
  );
}
